import {Form, InputNumber} from 'antd';
import styles from './mobileSetting.module.scss';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {useMutation} from '@apollo/client';
import {UPDATE_APP_CONFIGURATION} from 'graphql/queries/mobileSettings';
import {GET_APP_CONFIGURATION} from 'graphql/queries/mobileSettings';
import {ConfirmModal} from 'pages/adminOpportunities/stocksListings/ViewOrders/HandleOrders';
import {toast} from 'react-toastify';
import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';

export const SalesAgentSettings = ({data, refetch}) => {
  const [form] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.PlatformSettings),
  );

  const [updateAppConfig, {loading}] = useMutation(UPDATE_APP_CONFIGURATION, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
  });

  const prospectEligibilityDays =
    data?.prospectEligibilityDaysSincePrimaryAgentInteraction ?? null;

  useEffect(() => {
    form.setFieldsValue({
      prospectEligibilityDays: prospectEligibilityDays ?? null,
    });
  }, [prospectEligibilityDays, form]);

  const handleSubmit = () => {
    const value = form.getFieldValue('prospectEligibilityDays');
    const payload =
      value === '' || value === null || value === undefined
        ? null
        : Number(value);

    updateAppConfig({
      variables: {
        data: {
          salesAgentHub: {
            prospectEligibilityDaysSincePrimaryAgentInteraction: payload,
          },
        },
      },
      refetchQueries: [{query: GET_APP_CONFIGURATION}],
    })
      .then(({data: {updateAppConfig: result}}) => {
        if (result?.__typename === 'Error') {
          toast.error(result.message);
        } else {
          toast.success('Updated Successfully');
          setOpenModal(false);
          refetch?.();
        }
      })
      .catch(error => toast.error(error?.message || 'Update failed'));
  };

  return (
    <div className={styles.body}>
      <div className={styles.top}>
        <h1>Sales Agent Prospect Eligibility</h1>
        <p>
          Set the number of days since the primary sales agent last contacted a
          user. After this period, the user will be automatically reassigned to
          another agent.
        </p>
      </div>
      <div className={styles.salesAgentCard}>
        <Form
          form={form}
          onFinish={() => setOpenModal(true)}
          layout="vertical"
          className={styles.salesAgentForm}
          initialValues={{
            prospectEligibilityDays,
          }}>
          <Form.Item
            name="prospectEligibilityDays"
            label="Days since primary agent interaction"
            rules={[
              {
                required: true,
                message: 'Please enter the number of days',
              },
              {
                type: 'number',
                min: 1,
                message: 'Must be 1 or greater',
              },
            ]}>
            <InputNumber
              min={1}
              placeholder="e.g. 7"
              className={styles.salesAgentInput}
              parser={value => (value === '' ? '' : parseInt(value, 10))}
            />
          </Form.Item>
          <SubmitButton disabled={!tabOperations?.update} label="Update" />
        </Form>
      </div>
      <ConfirmModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        loading={loading}
        title="Confirm Update"
        confirmText="Are you sure you want to update the prospect eligibility days? Users may be reassigned to different sales agents based on this setting."
        handleOperation={handleSubmit}
      />
    </div>
  );
};
